export default __webpack_public_path__ + "static/banner-beano-6df25cd91a9b682882979277b2822943.png";